module.exports = __webpack_public_path__ + "static/media/BritishCouncil_Logo.2e7c2500.png";